import { createBrowserHistory } from "history";
import { renderNavBar } from "navigation";
import { LinkNames } from "navigation/App";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { Redirect, Route, Router } from "react-router-dom";
import { Utilities } from "shared/utilities";


import App from "./App";
import StylesheetProvider from "shared/providers/StylesheetProvider";


const browserHistory = createBrowserHistory({
    basename: Utilities.getBaseUrlPath("MonitoringRules/List/")
});

renderNavBar(browserHistory, LinkNames.monitoringrules);

const rootContainer = document.getElementById("MonitoringRulesRootContainer");
if (rootContainer) {
    const root = ReactDOM.createRoot(rootContainer);
    root.render(
        <React.StrictMode>
            <StylesheetProvider>
                <Router history={browserHistory}  >
                    <Route exact={true} path="/" render={() =>
                        <Redirect
                            to="/Default/Default"
                        />
                    } />
                    <Route path="/:environmentName/:agentGroupName?">
                        <App />
                    </Route>
                </Router>
            </StylesheetProvider>
        </React.StrictMode>
    );
}
